import React from 'react';
import './DashboardCard.css';

function DashboardCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  darkMode = false,
  onClick,
  arrow = false
}) {
  return (
    <div
      className={`dashboard-card ${darkMode ? 'dark' : ''} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        {arrow && <span className="card-arrow">→</span>}
      </div>

      {icon && <div className="card-icon">{icon}</div>}

      <div className="card-value">{value}</div>

      {subtitle && <div className="card-subtitle">{subtitle}</div>}

      {trend && (
        <div className={`card-trend ${trend.type}`}>
          <span className="trend-icon">{trend.type === 'up' ? '↑' : '↓'}</span>
          <span className="trend-text">{trend.text}</span>
        </div>
      )}
    </div>
  );
}

export default DashboardCard;
